$(".c-block-tabs__title").on('click', function(){
  var data = $(this).data('name');
  if (!$(this).hasClass('c-block-tabs__title--is-active')) {
    $(this).removeClass('c-block-tabs__title--is-active')
    $('.'+data+'.c-block-tabs__title--is-active').removeClass('c-block-tabs__title--is-active');
    $(this).addClass('c-block-tabs__title--is-active');
    var index = $(this).index();
    $( '.'+data+'.c-block-tabs__tab--is-active').removeClass('c-block-tabs__tab--is-active');
    $( '.'+data+'.c-block-tabs__tab').addClass('c-block-tabs__tab--hide');
    $( '.'+data+'.c-block-tabs__tab').removeClass('c-block-tabs__tab--fade');
    $( '.'+data+'.c-block-tabs__tab:eq('+index+')').addClass('c-block-tabs__tab--is-active');
    $( '.'+data+'.c-block-tabs__tab:eq('+index+')').removeClass('c-block-tabs__tab--hide');
    setTimeout(function() { $( '.'+data+'.c-block-tabs__tab:eq('+index+')').addClass('c-block-tabs__tab--fade'); }, 20);
  }
});